/**
 * Edit Tracking Reducers for RemitSlice
 * 
 * Handles tracking of edited fields and save/discard operations.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RemitSliceState } from '../state';

/**
 * Mark a field as edited
 */
export const markFieldAsEdited: CaseReducer<
  RemitSliceState,
  PayloadAction<string>
> = (state, action) => {
  const fieldName = action.payload;
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

/**
 * Clear all edited field markers
 */
export const clearEditedFields: CaseReducer<RemitSliceState> = (state) => {
  state.editedFields = [];
  state.isEdited = false;
};

/**
 * Mark remit as saved (update backup and clear edit state)
 */
export const markAsSaved: CaseReducer<RemitSliceState> = (state) => {
  if (state.currentRemit) {
    state.remitBackup = state.currentRemit;
  }
  state.isEdited = false;
  state.editedFields = [];
};

/**
 * Discard all changes and restore from backup
 */
export const discardChanges: CaseReducer<RemitSliceState> = (state) => {
  if (state.remitBackup) {
    state.currentRemit = state.remitBackup;
  }
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
};
